import React from 'react'
import styles from './email-changed.styles'
import injectSheet from 'react-jss'
import Container from '../components/container/container'
import Title from '../components/title/title'
import Description from '../components/description/description'
import duckFixer from '../../../../images/duck-fixer.gif'
import Button from 'pobble-components/dist/button'

const EmailChanged = ({ classes, params }) => (
  <Container>
    <img className={classes.img} src={duckFixer} alt="duck fixer" />
    <Title>Your email has been updated</Title>
    <Description>
      <p>
        Your new email is <strong>{params.new_email}</strong>
      </p>
    </Description>
    <Button tall href="/">
      Go to pobble
    </Button>
  </Container>
)

export default injectSheet(styles)(EmailChanged)
